import type { ProfileReviewGateway } from '../support/profileReview';

export async function makeProfileReviewGateway(): Promise<ProfileReviewGateway> {
    if (useRuntimeConfig().public.profileReviewMock) {
        const { default: ProfileReviewMock } = await import('./ProfileReviewMock');
        return new ProfileReviewMock();
    }

    const { default: ProfileReviewEndpoint } = await import('./ProfileReviewEndpoint');
    return new ProfileReviewEndpoint();
}
